import React, { useState } from "react";
import { Box, Drawer, IconButton, useMediaQuery, useTheme } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AppSidebar from "../AppSidebar";
import SelectUnidade from "../SelectUnidade";
import UserComponent from "../UserComponent";

const SIDEBAR_WIDTH = 260;
const SIDEBAR_COLLAPSED_WIDTH = 64;

function AppLayout({ children, currentPage = "home" }) {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("md"));
	const [mobileOpen, setMobileOpen] = useState(false);
	const [collapsed, setCollapsed] = useState(() => {
		return localStorage.getItem("sidebar_collapsed") === "true";
	});

	const handleDrawerToggle = () => {
		setMobileOpen(!mobileOpen);
	};

	const handleToggleCollapse = () => {
		const next = !collapsed;
		setCollapsed(next);
		localStorage.setItem("sidebar_collapsed", String(next));
	};

	return (
		<Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#f8f9fa" }}>
			{/* Sidebar - Desktop */}
			{!isMobile && (
				<Box
					sx={{
						width: collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH,
						flexShrink: 0,
						transition: "width 0.25s ease",
					}}
				>
					<AppSidebar
						currentPage={currentPage}
						collapsed={collapsed}
					/>
				</Box>
			)}

			{/* Botão flutuante de colapso — borda direita da sidebar */}
			{!isMobile && (
				<Box
					onClick={handleToggleCollapse}
					sx={{
						position: "fixed",
						left: (collapsed ? SIDEBAR_COLLAPSED_WIDTH : SIDEBAR_WIDTH) - 13,
						top: 72,
						width: 26,
						height: 26,
						borderRadius: "50%",
						bgcolor: "white",
						border: "1.5px solid #d0d5dd",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						cursor: "pointer",
						zIndex: 1300,
						transition: "left 0.25s ease, background-color 0.15s ease, border-color 0.15s ease",
						boxShadow: "0 1px 6px rgba(0,0,0,0.12)",
						color: "#1a9e8f",
						"&:hover": {
							bgcolor: "#1a9e8f",
							borderColor: "#1a9e8f",
							color: "white",
							boxShadow: "0 2px 8px rgba(26,158,143,0.35)",
						},
					}}
				>
					{collapsed
						? <ChevronRightIcon sx={{ fontSize: 16 }} />
						: <ChevronLeftIcon sx={{ fontSize: 16 }} />
					}
				</Box>
			)}

			{/* Sidebar - Mobile (Drawer) */}
			<Drawer
				variant="temporary"
				open={mobileOpen}
				onClose={handleDrawerToggle}
				ModalProps={{ keepMounted: true }}
				sx={{
					display: { xs: "block", md: "none" },
					"& .MuiDrawer-paper": {
						width: SIDEBAR_WIDTH,
						boxSizing: "border-box",
					},
				}}
			>
				<AppSidebar currentPage={currentPage} onClose={handleDrawerToggle} isDrawer />
			</Drawer>

			{/* Main Content */}
			<Box sx={{ flex: 1, display: "flex", flexDirection: "column", minHeight: "100vh", overflow: "hidden" }}>
				{/* Mobile Header */}
				{isMobile && (
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "space-between",
							px: 2,
							py: 1.5,
							bgcolor: "white",
							borderBottom: "1px solid #dfe3e8",
							position: "sticky",
							top: 0,
							zIndex: 100,
						}}
					>
						<IconButton onClick={handleDrawerToggle} sx={{ color: "#0f4557" }}>
							<MenuIcon />
						</IconButton>
						<SelectUnidade
							verticalAnchorOrigin="bottom"
							horizontalAnchorOrigin="center"
							verticalTransformOrigin="top"
							horizontalTransformOrigin="center"
						/>
						<UserComponent />
					</Box>
				)}

				{/* Page Content */}
				<Box
					component="main"
					sx={{
						flex: 1,
						overflow: "auto",
						p: { xs: 2, md: 4 },
					}}
				>
					{children}
				</Box>
			</Box>
		</Box>
	);
}

export default AppLayout;
